<template>
<main>
    <breadcrumbs></breadcrumbs>
    <div class="content-wrapper">
        <div class="content-width">
          <p class="margin-bottom-large">
              Elke transportonderneming die gevaarlijke stoffen vervoert, opslaat of produceert, moet een veiligheidsadviseur benoemen of extern inhuren. Rojeca Advies is er voor uw bedrijf om de beste oplossing te zoeken voor ADR en RID. Als veiligheidsadviseur houd ik voor iedere werknemer in uw bedrijf bij of deze een opleiding moet volgen om aan alle veiligheidseisen te voldoen.  Daarbij wordt er van uw bedrijf een veiligheidsjaarverslag bijgehouden, zodat u een overzichtelijke inzage heeft in de veiligheidsstatus van uw bedrijf. Rojeca Advies is aangesloten bij de vereniging van veiligheidsadviseurs ADR. Hierdoor ben ik bekend met de laatste ontwikkelingen en wetgevingen omtrent ADR.
          </p>
          <h1>Kernactiviteiten</h1>
          <div class="wrapper-kernactiviteit">
            <ul class="pretty">
              <li>Het toezien op naleving van de regels</li>
              <li>Nemen van maatregelen om ongelukken te voorkomen</li>
              <li>Het opstellen van noodprocedures</li>
              <li>Het melden van ongevallen waar gevaarlijke stoffen bij betrokken zijn</li>
            </ul>
            <img class="border" src="../assets/earmuffs_crop.jpg"/>
          </div>
        <router-link to="/contact"><button>Kom in contact</button></router-link>
        </div>
  
    </div>
</main>
</template>

<script>

import Breadcrumbs from './breadcrumbs'

export default {
  name: 'ContentTakenpakket',
  components: {
      Breadcrumbs
  },
  data () {
    return {
      msg: 'Welcome to Your Vue.js App'
    }
  },
  mounted() {
    window.scrollTo(0, 0);
  }
}
</script>

<style>
    .wrapper-kernactiviteit {
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      align-items: flex-start;
    }

    .wrapper-kernactiviteit img {
      margin-left: var(--item-margin);
      height: 240px;
      object-fit: contain;
    }
    @media only screen and (max-width: 600px) {
      .wrapper-kernactiviteit {
        flex-direction: column;
      }

      .wrapper-kernactiviteit img {
        width: 100%;
        object-fit: cover;
        margin: 0px 0px var(--item-margin) 0;
      }
    }

</style>


// WEBPACK FOOTER //
// src/components/content-takenpakket.vue